import axios from "axios";

export function isSignedIn() {
    return (localStorage.getItem("token") !== null)
}

export function signOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("token-expiry");

    setTimeout(() => {
        window.location.reload();
    }, 500)

    //window.dispatchEvent(new Event("sso-state"));
}

export const ssoURL = "https://account.samaggisamagom.com/authenticate?req=1f86d2c5-eb5e-4f72-a4c5-528a693407c9";

export async function checkToken() {
    return new Promise((resolve,) => {
        if (!isSignedIn()) {
            resolve(false);
            return
        }

        const token = localStorage.getItem("token");
        const expiryString = localStorage.getItem("token-expiry");

        let expiry = 0

        if (expiryString !== null) {
            expiry = parseFloat(expiryString);
        }

        if (Date.now() / 1000 > expiry && expiryString !== null) {
            resolve(false);
            signOut()
            return
        }

        axios.post("https://k3rkw7qg78.execute-api.eu-west-2.amazonaws.com/Prod/api/check-token", { "token": token }).then(res => {
            console.log(res);
            try {
                if (res.data.data.valid === true) {
                    localStorage.setItem("token-expiry", res.data.data.expiry);
                    resolve(true)
                    return
                }
                resolve(false)
                signOut()
            } catch (e) {
                console.warn(e);
                resolve(false)
                signOut()
            }
        }).catch((error) => {
            console.warn(error)
            try {
                if (error.response !== undefined) {
                    alert(error.response.data.data.reason);
                } else {
                    alert(error.code);
                }
            } catch (e) {
                alert(error.code);
                console.warn(e);
            }
            resolve(false);
        })
    })
}

export function handleError(error: any, quiet: boolean = false) {
    console.warn(error);

    try {
        if (error.response !== undefined) {
            const err = error.response.data.data.reason;
            if (err !== "Invalid Token" && err !== "Invalid Session") {
                alert(err);
            } else {
                console.log("Invalid Token");
            }
        } else {
            if (!quiet) {
                alert(error.code);
            }
        }
    } catch (e) {
        if (!quiet) {
            alert(error.code);
        }
        console.warn(e);
    }
}
